import { callApi } from "./index"

export const getLoginStatus = (): Promise<LoginStatus> => {
  return callApi("/api/EasyDirectoryAPI/login-status", { })
}

export interface LoginStatus {
  IsLoggedIn: boolean
  IsCompetitionEnabled: boolean
  ShowPromoModal: boolean
  MessagingEnabled?: boolean
}